<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader> <strong>搜尋條件</strong> </CCardHeader>
        <CCardBody>
          <CRow>
            <b-form-group label="類型" class="col-2">
              <b-form-select v-model="filter.type" :options="typelist"></b-form-select>
            </b-form-group>
            <b-form-group label="客戶編號或名稱" class="col-2">
              <b-form-input v-model="filter.search"></b-form-input>
            </b-form-group>
            <b-form-group label="縣市" class="col-2">
              <b-form-select v-model="filter.county" :options="counties"></b-form-select>
            </b-form-group>
            <b-form-group label="區域" class="col-2">
              <b-form-select v-model="filter.district" :options="districts"></b-form-select>
            </b-form-group>
          </CRow>
        </CCardBody>
        <CCardFooter class="text-right">
          <CButton type="submit" size="sm" color="success" class="mr-1" @click="search()">查詢</CButton>
          <CButton type="reset" size="sm" color="danger" @click="clearFilter()">清空</CButton>
        </CCardFooter>
      </CCard>

      <CCard>
        <CCardHeader> <strong>客戶列表</strong> </CCardHeader>
        <CCardBody>
          <div class="my-2 d-flex justify-content-between">
            <div></div>
            <div>
              <span class="text-primary">總計 {{ pageinfo.count }} 筆資料，共 {{ pageinfo.totalPage }} 頁，目前顯示第 {{ pageinfo.page }} 頁</span>
            </div>
          </div>
          <b-table striped hover bordered :items="datalist" :fields="fields" show-empty>
            <template #empty>
              <h2 class="text-secondary text-center m-4">無資料</h2>
            </template>
            <template #cell(area)="row"> {{ row.item.county }} {{ row.item.district }} </template>
            <template #cell(name)="row">
              {{ row.item.name ? row.item.name : row.item.contactName }}
              <span v-if="row.item.referrerNo && row.item.referrerName">({{ row.item.referrerNo }} - {{ row.item.referrerName }})</span>
            </template>
            <template #cell(action)="row">
              <b-button variant="primary" size="sm" :to="{ name: '客戶資料', params: { id: row.item.id } }">詳細資料</b-button>
            </template>
          </b-table>
          <b-pagination v-model="pageinfo.page" :total-rows="pageinfo.count" :per-page="pageinfo.limit" align="center" @change="getCustomers"></b-pagination>
        </CCardBody>
      </CCard>
      <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" no-wrap> </b-overlay>
    </CCol>
  </CRow>
</template>

<script>
export default {
  name: "CustomerViewPage",
  data() {
    return {
      loading: false,
      typelist: [],
      filter: {
        type: "",
        search: "",
        county: "",
        district: "",
      },
      fields: [
        {
          key: "type",
          label: "客戶類型",
          class: "text-center align-middle",
          formatter: (value) => this.getCustomerType(value),
        },
        { key: "no", label: "客戶編號", class: "text-center align-middle" },
        { key: "area", label: "地區", class: "text-center align-middle" },
        { key: "tax", label: "統一編號", class: "text-center align-middle" },
        { key: "name", label: "客戶名稱", tdClass: "align-middle", thClass: "text-center align-middle w-25" },
        { key: "contactName", label: "聯絡人", class: "text-center align-middle" },
        { key: "contactInformation", label: "聯絡人電話", class: "text-center align-middle" },
        { key: "action", label: "操作", class: "text-center align-middle" },
      ],
      datalist: [],
      pageinfo: {
        count: 11,
        limit: 10,
        page: 1,
        totalPage: 1,
      },
    };
  },
  computed: {
    counties() {
      return [{ text: "選擇縣市", value: "" }, ...this.$modules.CountyList.map((item) => item.name)];
    },
    districts() {
      let result = [{ text: "選擇區域", value: "" }];
      if (this.filter.county) {
        let list = this.$modules.CountyList.find((item) => item.name === this.filter.county).districts.map((item) => item.name);
        result = [...result, ...list];
      }
      return result;
    },
  },
  mounted() {
    this.getTypelist();
    this.getCustomers();
  },
  methods: {
    getTypelist() {
      this.typelist = [{ value: "", text: "全部類型" }, ...this.$modules.CustomerType];
    },
    getCustomerType(val) {
      let type = this.$modules.CustomerType.find((p) => p.value === val);
      return type.text;
    },
    getCustomers(page = null) {
      this.loading = true;
      let params = {
        params: {
          page: page === null ? this.pageinfo.page : page,
          type: this.filter.type,
          search: this.filter.search,
          county: this.filter.county,
          district: this.filter.district,
        },
      };
      this.$http.get("/customer/list", params).then((response) => {
        if (response.data.success) {
          this.datalist = response.data.result.datalist;
          this.pageinfo = response.data.result.pageinfo;
        } else {
          this.$notify({ type: "error", text: response.data.message });
        }
        this.loading = false;
      });
    },
    search() {
      this.pageinfo.page = 1;
      this.getCustomers();
    },
    clearFilter() {
      this.pageinfo.page = 1;
      this.filter.search = "";
      this.filter.county = "";
      this.filter.district = "";
      this.filter.type = "";
      this.search();
    },
  },
};
</script>